"use client";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect, useState } from "react";
import { isServer } from "@travel/shared/utils";
export var useLocalState = function (key, initialState, parser) {
    var _a = __read(useState(initialState), 2), state = _a[0], setState = _a[1];
    var _b = __read(useState(false), 2), hasCheckedLocal = _b[0], setHasCheckedLocal = _b[1];
    var set = useCallback(function (nextState, write) {
        if (write === void 0) { write = true; }
        if (!key)
            return;
        //if (nextState == state) return;
        setState(nextState);
        if (isServer || !write)
            return;
        if (nextState !== null && nextState !== undefined) {
            var localState = typeof nextState == "string" ? nextState : JSON.stringify(nextState);
            localStorage.setItem(key, localState);
        }
        else {
            localStorage.removeItem(key);
        }
    }, [key]);
    useEffect(function () {
        if (isServer || !key)
            return;
        var localItem = localStorage.getItem(key);
        var localState = initialState;
        try {
            if (localItem) {
                localState = JSON.parse(localItem);
            }
        }
        catch (_a) {
            localState = initialState;
        }
        setTimeout(function () {
            setHasCheckedLocal(true);
        });
        if (!localState)
            return;
        setState((parser === null || parser === void 0 ? void 0 : parser(localState)) || localState);
    }, [key]);
    return [state, set, hasCheckedLocal];
};
